import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { AnimatePresence, motion } from 'framer-motion'

import { questionList } from 'assets/data'
import Toggle from '../assets/icons/toggle.svg'
import ToggleChecked from '../assets/icons/toggle-checked.svg'
import { ContactSubmitModal } from './SubmitModal'
import { postContactMinute } from 'apis/contact.ts'

export default function ContactQuestion() {
  const [modalOpen, setModalOpen] = useState(false)
  const openModal = () => {
    setModalOpen(true)
  }

  const variants = {
    initial: (direction) => {
      return {
        opacity: 0,
        y: direction > 0 ? windowHeight() : -windowHeight(),
      }
    },
    animate: {
      opacity: 1,
      y: 0,
    },
    exit: (direction) => {
      return {
        opacity: 0,
        y: direction > 0 ? -windowHeight() : windowHeight(),
      }
    },
  }
  const [checkedValue, setCheckedValue] = useState([])
  const [additionalCheckedValue, setAdditionalCheckedValue] = useState([])
  const windowHeight = () => {
    return window.innerHeight
  }

  const regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i
  const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/

  const [isSubmit, setIsSubmit] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm()

  const onSubmit = async (data) => {
    const postContactMinuteResponse = await postContactMinute({
      service: data.service, // 20
      prevService: data.prevService, // 20
      payment: data.payment, // 20
      generalPayment: data.generalPayment ? data.generalPayment.join(',') : '', // 50
      easyPayment: data.easyPayment ? data.easyPayment.join(',') : '', // 50
      pointPayment: data.pointPayment ? data.pointPayment : '', // 20
      register: data.register, // 20
      socialRegister: data.socialRegister ? data.socialRegister : '', // 20
      delivery: data.delivery ? data.delivery : '', // 20
      notice: data.notice.join(','), // 50
      etcService: data.etcService.join(','), // 200
      message: data.message, // 500
      company: data.company, // 20
      name: data.name, // 20
      phone: data.phone, // 20
      email: data.email, // 50
      budget: data.budget, // 100
      reference: data.reference, // 200
      etcTechMessage: data.etcTechMessage, // 500
    })
    if (postContactMinuteResponse.error) {
      console.log(postContactMinuteResponse.error)
      return
    } else {
      console.log(postContactMinuteResponse)
    }
  }

  const [direction, setDirection] = useState(1)
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrev = () => {
    setDirection(-1)
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }

  const handleNext = () => {
    setDirection(1)
    if (currentIndex < questionList.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
  }

  const isCheckedValue = (setValue, type, key, value) => {
    setValue((prev) => {
      const existingValue = prev.find((item) => item.key === key)

      if (type === 'radio' && existingValue) {
        return prev.map((item) => (item.key === key ? { ...item, value } : item))
      } else {
        return [...prev, { key, value }]
      }
    })
  }
  const isChecked = (idx) => {
    const isCheckedKey = checkedValue.find((item) => item.key === idx)
    if (isCheckedKey) {
      return true
    } else {
      return false
    }
  }
  const isAdditionalChecked = (idx) => {
    const isCheckedKey = additionalCheckedValue.find((item) => item.key === idx)
    if (isCheckedKey) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className='h-screen wrapper question-box'>
      <motion.div
        className='fixed z-50 w-full h-[3px] bg-gradient-to-r from-[#FFFFFF] to-[#000000] rounded-full origin-left transition-all duration-300 ease-out '
        style={{ width: `${((currentIndex + 1) / questionList.length) * 100}%` }}
      ></motion.div>
      <div className=''>
        <div className='container relative px-20 mx-auto'>
          <form onSubmit={handleSubmit(onSubmit)}>
            {questionList.map((questionItem, index) => (
              <AnimatePresence custom={direction}>
                <motion.div
                  key={currentIndex}
                  variants={variants}
                  custom={direction}
                  initial='initial'
                  animate='animate'
                  exit='exit'
                  transition={{
                    duration: 0.7,
                    type: 'spring',
                  }}
                >
                  <div
                    key={index}
                    className={`absolute h-0 flex flex-col items-center right-[50%] left-[50%] ${
                      currentIndex === index
                        ? 'h-[calc(100vh-120px)] md:h-[calc(100vh-160px)]'
                        : 'overflow-hidden'
                    }
                    ${questionItem.idx === 8 ? 'top-60' : 'top-60 md:top-100'}
                  `}
                  >
                    <div className='flex flex-col items-center justify-center gap-40 md:gap-60'>
                      <div
                        className={`flex items-start  max-md:flex-col w-[300px] 2xs:w-[450px] md:w-[900px] lg:w-[1024px] max-md:items-center ${
                          questionItem.idx === 8
                            ? 'flex flex-col gap-20 2xs:gap-40'
                            : 'gap-30 md:gap-60 justify-between'
                        }
                      `}
                      >
                        <div className='flex flex-col items-start gap-8 shrink-0'>
                          <p className='whitespace-pre-wrap text-title3-bold 2xs:text-title2-bold sm:text-title1-bold text-sk-black'>
                            {questionItem.title}
                          </p>
                          <p className='whitespace-pre-wrap text-body1-medium 2xs:text-h2-medium sm:text-h1-medium text-sk-info'>
                            {questionItem.subTitle}
                          </p>
                        </div>
                        {questionItem.idx !== 8 && (
                          <div
                            className={`${
                              questionItem.answer.length > 6
                                ? 'grid grid-cols-2 gap-12 md:flex md:flex-col'
                                : ''
                            }
                      flex flex-col items-start gap-12 max-md:items-center`}
                          >
                            {questionList[index].answer.map((answerItem, answerIndex) => (
                              <label
                                key={answerIndex}
                                className={`relative box_select has-[:checked]:box_selected md:w-[240px] lg:w-[345px]
                         ${
                           isChecked(questionItem.idx) === false
                             ? 'box_select'
                             : checkedValue[index].value === answerItem.content
                             ? 'box_selected'
                             : questionItem.type === 'radio'
                             ? 'box_disabled'
                             : 'box_select'
                         }
                          ${questionItem.idx === 8 ? 'hidden' : null}
                          ${
                            questionItem.answer.length > 6
                              ? 'w-[140px] 2xs:w-[200px]'
                              : 'w-[240px] 2xs:w-[345px] lg:w-[345px]'
                          }
                          
                         `}
                              >
                                <p>{answerItem.content}</p>
                                <input
                                  {...register(`${questionItem.name}`, {
                                    required: true,
                                    pattern:
                                      questionItem.name === 'email'
                                        ? regEmail
                                        : questionItem.name === 'phone'
                                        ? regPhone
                                        : null,
                                  })}
                                  type={questionItem.type}
                                  value={answerItem.content}
                                  label={answerItem.content}
                                  className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                                  style={{
                                    backgroundImage: `url(${Toggle})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                  }}
                                  onClick={(e) => {
                                    isCheckedValue(
                                      setCheckedValue,
                                      questionItem.type,
                                      questionItem.idx,
                                      e.target.value
                                    )
                                  }}
                                />
                                <img
                                  className='absolute invisible peer-checked:visible right-16'
                                  src={ToggleChecked}
                                  alt=''
                                />
                              </label>
                            ))}
                          </div>
                        )}
                        {questionItem.idx === 8 && (
                          <div className='flex flex-col gap-60'>
                            <div className='flex flex-col items-center justify-center gap-24'>
                              {questionItem.answer.map((answerItem, answerIndex) => (
                                <div
                                  key={answerIndex}
                                  className='flex items-center justify-between gap-20 2xs:gap-40 w-[300px] 2xs:w-[450px] md:w-[800px] lg:w-[1024px]'
                                >
                                  <p className='min-w-[90px] lg::min-w-120'>{answerItem.content}</p>
                                  <input
                                    {...register(`${answerItem.name}`, { required: true })}
                                    type='text'
                                    placeholder={
                                      answerIndex === 2
                                        ? `${answerItem.content}를 작성해주세요`
                                        : answerIndex === 5
                                        ? `${answerItem.content}를 작성해주세요`
                                        : `${answerItem.content}을 작성해주세요`
                                    }
                                    className='w-full outline-none box_select text-h2-medium text-sk-default placeholder:text-body2-medium placeholder:2xs:text-body1-medium placeholder:text-sk-assistive'
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      {questionList[index].idx === 7 && (
                        <div className='flex flex-col items-start  max-md:flex-col sm:w-[480px] md:w-[900px] lg:w-[1024px] gap-20 2xs:gap-30 md:gap-60 max-md:items-center'>
                          <p className='whitespace-pre-wrap text-h2-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-black'>
                            기타 필요하신 기능이 있으시면 적어주세요
                          </p>
                          <textarea
                            {...register('message')}
                            rows={3}
                            className='w-full p-16 outline-none resize-none box_select text-body1-semibold text-sk-sub'
                          />
                        </div>
                      )}
                      {/* 추가 질문 */}
                      {questionList[index].additionalQuestion &&
                        isChecked(questionItem.idx) &&
                        checkedValue[index].value === `네` && (
                          <div className='flex flex-col items-start justify-between gap-40'>
                            {questionList[index].additionalQuestion.map(
                              (additionalQuestionItem, additionalQIndex) => (
                                <div
                                  key={additionalQIndex}
                                  className='flex justify-between  max-md:flex-col w-[300px] 2xs:w-[450px] md:w-[900px] lg:w-[1024px] gap-30 md:gap-60 max-md:items-center'
                                >
                                  <div className='flex flex-col items-start gap-8'>
                                    <p className='whitespace-pre-wrap text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-black'>
                                      {additionalQuestionItem.title}
                                    </p>
                                    <p className='whitespace-pre-wrap text-body2-medium 2xs:text-body1-medium sm:text-h2-medium text-sk-info'>
                                      {additionalQuestionItem.subTitle}
                                    </p>
                                  </div>
                                  <div className='grid items-start justify-between grid-cols-2 gap-12 2xs:grid 2xs:grid-cols-3 md:grid-cols-2'>
                                    {additionalQuestionItem.answer.map(
                                      (answerItem, answerIndex) => (
                                        <label
                                          key={answerIndex}
                                          className={`relative box_select has-[:checked]:box_selected w-[140px] md:w-[167px]
                                        ${
                                          additionalQuestionItem.type === 'radio' &&
                                          isAdditionalChecked(
                                            `${questionItem.idx}-${additionalQuestionItem.idx}`
                                          ) &&
                                          (additionalCheckedValue.value === answerItem.content
                                            ? 'box_selected'
                                            : 'box_disabled')
                                        }`}
                                        >
                                          <p>{answerItem.content}</p>
                                          <input
                                            {...register(`${additionalQuestionItem.name}`, {
                                              required: true,
                                            })}
                                            type={additionalQuestionItem.type}
                                            value={answerItem.content}
                                            label={answerItem.content}
                                            className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                                            style={{
                                              backgroundImage: `url(${Toggle})`,
                                              backgroundRepeat: 'no-repeat',
                                              backgroundPosition: 'center',
                                            }}
                                            onClick={(e) => {
                                              isCheckedValue(
                                                setAdditionalCheckedValue,
                                                additionalQuestionItem.type,
                                                `${questionItem.idx}-${additionalQuestionItem.idx}`,
                                                e.target.value
                                              )
                                            }}
                                          />
                                          <img
                                            className='absolute invisible peer-checked:visible right-16'
                                            src={ToggleChecked}
                                            alt=''
                                          />
                                        </label>
                                      )
                                    )}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      <div
                        className={`flex items-center gap-32 ${
                          questionItem.idx === 8 ? 'mb-60' : 'mb-60 md:mb-100'
                        }`}
                      >
                        {index !== 0 && (
                          <button
                            type='button'
                            className='px-48 py-12 button_white2 text-body1-medium text-sk-default'
                            onClick={() => {
                              handlePrev()
                              window.scrollTo(0, 0)
                            }}
                          >
                            이전
                          </button>
                        )}
                        {isChecked(questionItem.idx) && (
                          <button
                            type='button'
                            className={`${
                              questionItem.idx === 8
                                ? 'hidden'
                                : 'px-48 py-12 button_black text-sk-white text-body1-medium'
                            }`}
                            onClick={() => {
                              handleNext()
                              window.scrollTo(0, 0)
                            }}
                          >
                            다음
                          </button>
                        )}
                        {questionItem.idx === 8 && (
                          <button
                            disabled={!isValid}
                            type='submit'
                            className='px-48 py-12 button_black text-sk-white text-body1-medium'
                            onClick={() => {
                              setIsSubmit((prev) => !prev)
                              openModal()
                            }}
                          >
                            완료
                          </button>
                        )}
                        {modalOpen && (
                          <ContactSubmitModal setModalOpen={setModalOpen} isSubmit={isSubmit} />
                        )}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            ))}
          </form>
        </div>
      </div>
    </div>
  )
}
